module.exports = __webpack_public_path__ + "static/img/modernWeb192.5c00f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/modernWeb19/modernWeb192.jpg
// module id = h0yz
// module chunks = 1